import { config } from 'zod';

/**
 * Zod, told not to compile its validators with `new Function`.
 *
 * It decides by trying one, and the app ships `script-src 'self'`, so the
 * browser refuses. Zod falls back correctly and nothing breaks — but it logged
 * a blocked `eval` on every page load, which is a real violation in every
 * coach's console and exactly the noise a genuine one would hide in. The
 * Workers runtime is detected and handled; a browser is not.
 *
 * **This has to be its own module.** Said at the top of `main.tsx` it was still
 * too late: imports are evaluated before any statement in the file that makes
 * them, and the schemas built at module scope had already asked the question.
 * Imported first, this runs first.
 */
config({ jitless: true });
